import apiFetch from '../apiFetch'

export default function (rfid, token) {
  return apiFetch({endPoint: `Operario/getOperarioRfid?rfid=${rfid}`, method: 'GET', body: null, token: token})
}
